module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_c('b', [_vm._v("Cercador d’Instamaps")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Utilitza o servei de geocodificació de l’ICGC permet obtenir les coordenades d’un lloc ubicat a Catalunya\n\t\t\t a partir de la seva adreça postal, del seu nom (topònim) o del punt quilomètric\n\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00e0ede6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/map-viewer/components/floating-sidemenu/helpSearch.vue
// module id = 123
// module chunks = 0